import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

import { useOidcAuth } from '@/features/login/model/use-oidc-auth';
import { OidcProvider } from '@/shared/config/oidc-config';

export const WFPUsersSection = () => {
  const { loginWithRedirect, isLoading } = useOidcAuth(OidcProvider.AZURE);

  return (
    <Card>
      <CardHeader className="text-center">
        <CardTitle data-testid="wfp-users-section-title" className="text-lg">
          WFP Users
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <Button className="w-full" size="lg" onClick={loginWithRedirect} disabled={isLoading}>
          {isLoading ? 'Logging in...' : 'Login to RITA'}
        </Button>
      </CardContent>
    </Card>
  );
};
